 import { Component } from '@angular/core';

@Component({
  selector: 'background-image',
  templateUrl: 'background-image.component.html'
})
export class BackgroundImageComponent {
  public bgImage;

  private images = Array("img/bigdsc00457.jpg", "img/bigdsc05466.jpg", "img/bigdsc05504.jpg", "img/bigdsc05520.jpg", "img/bigdsc06660.jpg", "img/bigdsc06667.jpg",
      "img/bigdsc06801.jpg", "img/bigdsc08121m.jpg", "img/bigdsc08223m.jpg");

  constructor() {
    let imageNr = Math.trunc(Math.random()*this.images.length);
    if (imageNr==this.images.length) imageNr-=1;
    this.bgImage = 'assets/'+this.images[imageNr];
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/background-image/background-image.component.ts